import { render, staticRenderFns } from "./AccountSortData.vue?vue&type=template&id=02dd2425&scoped=true"
import script from "./AccountSortData.vue?vue&type=script&lang=js"
export * from "./AccountSortData.vue?vue&type=script&lang=js"
import style0 from "./AccountSortData.vue?vue&type=style&index=0&id=02dd2425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dd2425",
  null
  
)

export default component.exports